import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ConfigService } from 'app/services/config/config.service';

export const landingPageGuard: CanActivateFn = route => {
  const configuration = inject(ConfigService).settings;
  if (!configuration || configuration.visibilityControl?.landingPageEnabled) return true;
  return inject(Router).createUrlTree(['/', route.parent!.paramMap.get('lang'), 'locker-locations']);
};
